import { Link, useLocation } from 'react-router-dom'
// import styles from './navbar.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { disconnectSocket, logout } from '../../features/authSlice'
import { useParams } from 'react-router-dom'

// mui icons
import PeopleIcon from '@mui/icons-material/People'
import LogoutIcon from '@mui/icons-material/Logout'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { SvgIcon, Tooltip, Typography } from '@mui/material'
import { memo, useEffect } from 'react'
import { countUnreadNotificationsKazoo } from '../../features/notificationSlice'
import NotificationsIcon from '@mui/icons-material/Notifications'

import Badge from '@mui/material/Badge'
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'
import { toggleSidebar } from '../../features/sidebarSlice'
import {
    InvitePartnerIcon,
    BudgetIcon,
    TasksIcon,
    VendorTrackerIcon,
} from './Icons'
import styles from './sidebar.module.scss'

// Sidebar navigation component for navigating between app sections
// Props:
const NavItem = memo(
    ({
        icon,
        label,
        to,
        dataTestId,
        isSidebarOpen,
        isIconComponent = false,
        notificationBadge = null,
    }) => {
        const location = useLocation()
        const pathname = location.pathname
        return (
            <li data-cy={dataTestId}>
                <Tooltip
                    title={label}
                    placement="right"
                    disableInteractive
                    arrow
                >
                    <Link
                        to={to}
                        className={pathname === to ? styles.activeNavItem : ''}
                    >
                        {notificationBadge ? (
                            <Badge
                                badgeContent={notificationBadge}
                                color="primary"
                                max={999}
                            >
                                {isIconComponent ? (
                                    icon
                                ) : (
                                    <img src={icon} alt={`${label}-icon`} />
                                )}
                            </Badge>
                        ) : isIconComponent ? (
                            icon
                        ) : (
                            <img src={icon} alt={`${label}-icon`} />
                        )}
                        {isSidebarOpen && (
                            <Typography
                                variant="body1"
                                className={`${styles.linkText} linkText`}
                            >
                                {label}
                            </Typography>
                        )}
                    </Link>
                </Tooltip>
            </li>
        )
    }
)

export const KazooSideNavbar = () => {
    const dispatch = useDispatch()
    const { kazooId } = useParams()
    const userId = useSelector((state) => state.auth?.user?._id)

    const role = useSelector((state) => state.kazooEvent.role)
    const accountType = useSelector((state) => state.auth.accountType)
    const numUnreadNotificationsKazoo = useSelector(
        (state) => state.notification.numUnreadNotificationsKazoo
    )

    const createRoleBasedRoutes = (kazooId) => ({
        bride: [
            {
                id: 'home',
                icon: <ArrowBackIcon style={{ color: '#7ca6bd' }} />,
                label: 'Home',
                to: '/user-dashboard',
                dataCy: 'home',
                isIconComponent: true,
            },
            {
                id: 'dashboard',
                icon: '/images/graph.svg',
                label: 'Dashboard',
                to: `/wedding/wedding-dashboard/${kazooId}`,
                dataCy: 'dashboard',
            },
            {
                id: 'invitePartner',
                icon: <InvitePartnerIcon />,
                label: 'Invite Partner',
                to: `/wedding/invite-your-partner/${kazooId}`,
                dataCy: 'invite',
                isIconComponent: true,
            },
            {
                id: 'tasks',
                icon: '/images/task-square-blue.svg',
                label: 'Tasks',
                to: `/wedding/tasks/${kazooId}`,
                dataCy: 'tasks',
            },
            {
                id: 'budget',
                icon: '/images/dollar-circle.svg',
                label: 'Budget',
                to: `/wedding/budget-tracker/${kazooId}`,
                dataCy: 'budget',
            },
            {
                id: 'timeline',
                icon: '/images/timeline-icon.svg',
                label: 'Timeline',
                to: `/wedding/timeline/${kazooId}`,
                dataCy: 'timeline',
            },
            {
                id: 'guests',
                icon: <PeopleIcon style={{ color: '#7ca6bd' }} />,
                label: 'Guests',
                to: `/wedding/wedding-guests/${kazooId}`,
                dataCy: 'guests',
                isIconComponent: true,
            },
            {
                id: 'vendorTracker',
                icon: '/images/icon-vendor_tracker.svg',
                label: 'Vendor Tracker',
                to: `/wedding/vendors/${kazooId}`,
                dataCy: 'vendors',
            },
            {
                id: 'vendors',
                icon: '/images/buliding.svg',
                label: 'Vendor Marketplace',
                to: '/vendors-list',
                dataCy: 'vendors-list-button',
            },
            {
                id: 'venues',
                icon: '/images/venues-icn.svg',
                label: 'Venues Marketplace',
                to: '/venues-list',
                dataCy: 'venues-list-button',
            },
            {
                id: 'planners',
                icon: '/images/planner-icon.svg',
                label: 'Planner Marketplace',
                to: '/planners-list',
                dataCy: 'planners-list-button',
            },
            {
                id: 'chat',
                icon: '/images/chat-icon.svg',
                label: 'Chat',
                to: `/wedding/chat/${kazooId}`,
                dataCy: 'chat-link',
            },
        ],
        groom: [
            {
                id: 'home',
                icon: <ArrowBackIcon style={{ color: '#7ca6bd' }} />,
                label: 'Home',
                to: '/user-dashboard',
                dataCy: 'dashboard',
                isIconComponent: true,
            },
            {
                id: 'dashboard',
                icon: '/images/graph.svg',
                label: 'Dashboard',
                to: `/wedding/wedding-dashboard/${kazooId}`,
                dataCy: 'dashboard',
            },
            {
                id: 'invitePartner',
                icon: <InvitePartnerIcon />,
                label: 'Invite Partner',
                to: `/wedding/invite-your-partner/${kazooId}`,
                dataCy: 'invite',
                isIconComponent: true,
            },
            {
                id: 'tasks',
                icon: '/images/task-square-blue.svg',
                label: 'Tasks',
                to: `/wedding/tasks/${kazooId}`,
                dataCy: 'tasks',
            },
            {
                id: 'budget',
                icon: '/images/dollar-circle.svg',
                label: 'Budget',
                to: `/wedding/budget-tracker/${kazooId}`,
                dataCy: 'budget',
            },
            {
                id: 'timeline',
                icon: '/images/timeline-icon.svg',
                label: 'Timeline',
                to: `/wedding/timeline/${kazooId}`,
                dataCy: 'timeline',
            },
            {
                id: 'guests',
                icon: <PeopleIcon style={{ color: '#7ca6bd' }} />,
                label: 'Guests',
                to: `/wedding/wedding-guests/${kazooId}`,
                dataCy: 'guests',
                isIconComponent: true,
            },
            {
                id: 'vendorTracker',
                icon: '/images/icon-vendor_tracker.svg',
                label: 'Vendor Tracker',
                to: `/wedding/vendors/${kazooId}`,
                dataCy: 'vendors',
            },
            {
                id: 'vendors',
                icon: '/images/buliding.svg',
                label: 'Vendor Marketplace',
                to: '/vendors-list',
                dataCy: 'vendors-list-button',
            },
            {
                id: 'venues',
                icon: '/images/venues-icn.svg',
                label: 'Venues Marketplace',
                to: '/venues-list',
                dataCy: 'venues-list-button',
            },
            {
                id: 'planners',
                icon: '/images/planner-icon.svg',
                label: 'Planner Marketplace',
                to: '/planners-list',
                dataCy: 'planners-list-button',
            },
            {
                id: 'chat',
                icon: '/images/chat-icon.svg',
                label: 'Chat',
                to: `/wedding/chat/${kazooId}`,
                dataCy: 'chat-link',
            },
        ],
        guest: [
            {
                id: 'home',
                icon: <ArrowBackIcon style={{ color: '#7ca6bd' }} />,
                label: 'Home',
                to: '/user-dashboard',
                dataCy: 'dashboard',
                isIconComponent: true
            },
            {
                id: 'dashboard',
                icon: '/images/graph.svg',
                label: 'Dashboard',
                to: `/wedding/wedding-dashboard/${kazooId}`,
                dataCy: 'dashboard',
            },
            {
                id: 'chat',
                icon: '/images/chat-icon.svg',
                label: 'Chat',
                to: `/wedding/chat/${kazooId}`,
                dataCy: 'chat-link',
            },
        ],
        vendor: [
            {
                id: 'home',
                icon: <ArrowBackIcon style={{ color: '#7ca6bd' }} />,
                label: 'Home',
                to: '/user-dashboard',
                dataCy: 'dashboard',
                isIconComponent: true
            },
            {
                id: 'dashboard',
                icon: '/images/graph.svg',
                label: 'Dashboard',
                to: `/wedding/details/${kazooId}`,
                dataCy: 'dashboard',
            },
            // {
            //     id: 'vendorWeddings',
            //     icon: '/images/lovely.svg',
            //     label: 'Weddings',
            //     to: '/vendor-weddings',
            //     dataCy: 'dashboard',
            // },
            // {
            //     id: 'vendorProfile',
            //     icon: '/images/profile-user.svg',
            //     label: 'Public Profile',
            //     to: `/profile/${userId}`,
            //     dataCy: 'vendor-profile',
            // },
            // {
            //     id: 'vendorSchedule',
            //     icon: '/images/timeline-icon.svg',
            //     label: 'Schedule',
            //     to: '/vendor-timeline',
            //     dataCy: 'vendor-timeline',
            // },
            /* TODO: uncomment when implemented */
            // {
            // 	id: 'vendorStaffs',
            // 	icon: <BadgeOutlinedIcon style={{ color: '#7ca6bd' }} />,
            // 	label: 'Staff',
            // 	to: '/invite-staff',
            // 	dataCy: 'vendor-staffs-link',
            // 	isIconComponent: true,
            // },
            // {
            //     id: 'vendorTasks',
            //     icon: '/images/task-square-blue.svg',
            //     label: 'Tasks',
            //     to: '/vendor-tasks',
            //     dataCy: 'vendor-tasks-link',
            // },
            // {
            //     id: 'vendorProposals',
            //     icon: '/images/proposal-icon.svg',
            //     label: 'Proposals',
            //     to: '/vendor-proposal',
            //     dataCy: 'proposal-link',
            // },
            /* TODO: uncomment when implemented */
            // {
            // 	id: 'vendorPayments',
            // 	icon: '/images/budget.svg',
            // 	label: 'Payments',
            // 	to: '/vendor-payments',
            // 	dataCy: 'vendor-payments-link',
            // },
            {
                id: 'tasks',
                icon: '/images/task-square-blue.svg',
                label: 'Tasks',
                to: `/wedding/vendor-tasks/${kazooId}`,
                dataCy: 'tasks-link',
            },
            {
                id: 'chat',
                icon: '/images/chat-icon.svg',
                label: 'Chat',
                to: `/wedding/vendor-chat/${kazooId}`,
                dataCy: 'chat-link',
            },
        ],
        'kazoo-planner': [
            {
                id: 'home',
                icon: <ArrowBackIcon style={{ color: '#7ca6bd' }} />,
                label: 'Home',
                to: '/user-dashboard',
                dataCy: 'dashboard',
                isIconComponent: true,
            },
            {
                id: 'dashboard',
                icon: '/images/graph.svg',
                label: 'Dashboard',
                to: `/wedding/wedding-dashboard/${kazooId}`,
                dataCy: 'dashboard',
            },
            {
                id: 'invitePartner',
                icon: <InvitePartnerIcon />,
                label: 'Invite Partner',
                to: `/wedding/invite-your-partner/${kazooId}`,
                dataCy: 'invite',
                isIconComponent: true,
            },
            {
                id: 'tasks',
                icon: '/images/task-square-blue.svg',
                label: 'Tasks',
                to: `/wedding/tasks/${kazooId}`,
                dataCy: 'tasks',
            },
            {
                id: 'budget',
                icon: '/images/dollar-circle.svg',
                label: 'Budget',
                to: `/wedding/budget-tracker/${kazooId}`,
                dataCy: 'budget',
            },
            {
                id: 'timeline',
                icon: '/images/timeline-icon.svg',
                label: 'Timeline',
                to: `/wedding/timeline/${kazooId}`,
                dataCy: 'timeline',
            },
            {
                id: 'guests',
                icon: <PeopleIcon style={{ color: '#7ca6bd' }} />,
                label: 'Guests',
                to: `/wedding/wedding-guests/${kazooId}`,
                dataCy: 'guests',
                isIconComponent: true,
            },
            {
                id: 'vendorTracker',
                icon: '/images/icon-vendor_tracker.svg',
                label: 'Vendor Tracker',
                to: `/wedding/vendors/${kazooId}`,
                dataCy: 'vendors',
            },
            {
                id: 'vendors',
                icon: '/images/buliding.svg',
                label: 'Vendor Marketplace',
                to: '/vendors-list',
                dataCy: 'vendors-list-button',
            },
            {
                id: 'venues',
                icon: '/images/venues-icn.svg',
                label: 'Venues Marketplace',
                to: '/venues-list',
                dataCy: 'venues-list-button',
            },
            {
                id: 'planners',
                icon: '/images/planner-icon.svg',
                label: 'Planner Marketplace',
                to: '/planners-list',
                dataCy: 'planners-list-button',
            },
            {
                id: 'chat',
                icon: '/images/chat-icon.svg',
                label: 'Chat',
                to: `/wedding/chat/${kazooId}`,
                dataCy: 'chat-link',
            },
        ],
        'vendor-staff': [
            {
                id: 'home',
                icon: <ArrowBackIcon style={{ color: '#7ca6bd' }} />,
                label: 'Home',
                to: '/user-dashboard',
                dataCy: 'dashboard',
                isIconComponent: true,
            },
            {
                id: 'dashboard',
                icon: '/images/graph.svg',
                label: 'Dashboard',
                to: `/wedding/details/${kazooId}`,
                dataCy: 'dashboard',
            },
            {
                id: 'chat',
                icon: '/images/chat-icon.svg',
                label: 'Chat',
                to: `/wedding/vendor-chat/${kazooId}`,
                dataCy: 'chat-link',
            },
        ],
        'planner-staff': [
            {
                id: 'home',
                icon: <ArrowBackIcon style={{ color: '#7ca6bd' }} />,
                label: 'Home',
                to: '/user-dashboard',
                dataCy: 'dashboard',
            },
            {
                id: 'dashboard',
                icon: '/images/graph.svg',
                label: 'Dashboard',
                to: `/wedding/details/${kazooId}`,
                dataCy: 'dashboard',
            },
            {
                id: 'chat',
                icon: '/images/chat-icon.svg',
                label: 'Chat',
                to: `/wedding/vendor-chat/${kazooId}`,
                dataCy: 'chat-link',
            },
        ],
    })

    // Logs the user out
    const handleLogout = async () => {
        dispatch(disconnectSocket())
        dispatch(logout())
    }

    const isSidebarOpen = useSelector((state) => state.sidebar.isSidebarOpen)
    const handleSidebarExpand = () => {
        dispatch(toggleSidebar())
    }

    const roleBasedRoutesData = createRoleBasedRoutes(kazooId)
    // check-kazoo-auth now returns `owner` for the wedding creator (ownerId).
    // The kazoo sidebar was built around bride/groom, so treat owner as couple.
    const navRole = role === 'owner' ? 'bride' : role
    const currentRoutes =
        navRole && roleBasedRoutesData[navRole]
            ? roleBasedRoutesData[navRole]
            : accountType && roleBasedRoutesData[accountType]
                ? roleBasedRoutesData[accountType]
                : []

    useEffect(() => {
        dispatch(countUnreadNotificationsKazoo(kazooId))
    }, [dispatch])

    return (
        <>
            <div className={`${styles.SideNavbar} SideNavbar`} data-cy="side-navbar">
                <div className={styles.sideTop}>
                    {isSidebarOpen ? (
                        <Link to="/" className={styles.sidebarLogoFull}>
                            <img
                                src={'/images/ontimebridelogo.svg'}
                                alt="Wedding Planner Logo"
                            />
                        </Link>
                    ) : (
                        <Link to="/" className={styles.sidebarLogo}>
                            <img
                                src={'/images/sidebarLogo.svg'}
                                alt="Wedding Planner Logo"
                            />
                        </Link>
                    )}

                    <ul className={styles.topNav}>
                        {currentRoutes.map((route) => (
                            <NavItem
                                key={route.id}
                                icon={route.icon}
                                label={route.label}
                                to={route.to}
                                dataTestId={route.dataCy}
                                isSidebarOpen={isSidebarOpen}
                                isIconComponent={route.isIconComponent}
                                notificationBadge={
                                    route.id === 'notifications'
                                        ? numUnreadNotificationsKazoo
                                        : null
                                }
                            />
                        ))}
                    </ul>
                </div>

                <ul className={styles.bottomNav}>
                    <li data-cy="logout">
                        <Tooltip
                            title="Log Out"
                            placement="right"
                            disableInteractive
                            arrow
                        >
                            <button
                                type="button"
                                onClick={handleLogout}
                                className={styles.logoutButton}
                            >
                                <LogoutIcon style={{ color: '#7ca6bd' }} />
                                {isSidebarOpen && (
                                    <Typography
                                        variant="body1"
                                        className={`${styles.linkText} linkText`}
                                    >
                                        logout
                                    </Typography>
                                )}
                            </button>
                        </Tooltip>
                    </li>
                </ul>
            </div>
            <div className="overlay" onClick={handleSidebarExpand}></div>
        </>
    )
}
